<template>
	<div class="ClientHistory">
		<div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<card card-body-classes="table-full-width">
			<!--h4 slot="header" class="card-title">История изменений по клиенту</h4-->
			
			<div>
				<div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
					<!--base-input>
						<el-input
							type="search"
							class="mb-3 search-input"
							clearable
							prefix-icon="el-icon-search"
							placeholder="Поиск"
							v-model="searchQuery"
							aria-controls="datatables"
						>
						</el-input>
					</base-input-->
				</div>
				<el-table :data="masHistory" class="my_hover">
					<el-table-column
						min-width="100"
						prop="dt_change_f"
						label="Дата изменения"
					>
					</el-table-column>
					<el-table-column
						min-width="100"
						prop="field_descr"
						label="Описание изменения"
					>
					</el-table-column>
					<el-table-column
						min-width="100"
						prop="field_value_old"
						label="Старое значение"
					>
					</el-table-column>
					<el-table-column
						min-width="100"
						prop="field_value_new"
						label="Новое значение"
					>
					</el-table-column>
					<el-table-column
						min-width="100"
						prop="staff_fio"
						label="Кто изменил"
					>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
				<Pagination :class="[{'': parseInt(history_total) > 0}, {'d-none': parseInt(history_total) < 1}]"
					:type="'primary'" 
					:total="parseInt(history_total)" 
					:perPage="parseInt(20)" 
					:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
					:pClick="pClick">
				</Pagination>
			</div>
		</card>
	</div>
</template>
<script>

import { Table, TableColumn } from 'element-ui';
import Pagination from 'src/our_components/RePagination';
export default {
	name: 'Client_history-page',
	components: {
		Pagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			masHistory: [],
			history_total:0,
			searchQuery:'',
			objGetParams: {},
		};
	},
	methods: {
		getHistory(){
			this.objGetParams = this.$GVO.GetAllGet();
			const client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('GET_HISTORY',{obj:'client',flt:{id:client_id, ...filter}})
			.then((objApi) => {
				this.masHistory = [];
				this.history_total = 0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.masHistory = objApi.data;
					}
					if(objApi.total!=undefined) { this.history_total=objApi.total; }
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});

			this.getHistory();
		},		
		GoBack(){
			this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id});
			// this.$router.back();
		},

	},
	mounted() {
		this.getHistory();
	}
};
</script>
<style >
	.el-table.my_hover .el-table__body tr:hover > td{
		background-color: rgb(1, 176, 224, 0.33) !important;
		cursor: pointer;
	}
	.ClientHistory .bntGroup{
		position: absolute;
		z-index: 1;
		right: 40px;
	}
</style>
